import { render, staticRenderFns } from "./CurrentPositionData.vue?vue&type=template&id=31d72796&scoped=true&"
import script from "./CurrentPositionData.vue?vue&type=script&lang=js&"
export * from "./CurrentPositionData.vue?vue&type=script&lang=js&"
import style0 from "./CurrentPositionData.vue?vue&type=style&index=0&id=31d72796&prod&lang=scss&scoped=true&"
import style1 from "./CurrentPositionData.vue?vue&type=style&index=1&id=31d72796&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d72796",
  null
  
)

export default component.exports